import styled from 'styled-components';
import { Stack } from './Stack';
import { lineHeight } from '../style';

export const FormLinks = styled(Stack).attrs({ space: lineHeight / 2 })`
  margin-top: ${lineHeight * 2}px;
`;
